// src/lib/format.js

const PARTICLES = new Set([
  'de', 'del', 'della', 'di', 'da', 'dos', 'das',
  'la', 'le', 'el', 'van', 'von', 'der', 'den', 'ter',
  'bin', 'ibn', 'al', 'y', 'e'
]);

export const capitalizeName = (name) => {
  if (!name) return '';

  const fixWord = (word) => {
    const letters = word.replace(/[^a-zA-Z]/g, '');
    const allUpper = letters && letters === letters.toUpperCase();
    const allLower = letters && letters === letters.toLowerCase();
    if (allUpper || allLower) {
      return word.toLowerCase()
        .replace(/(^|[\-'])([a-z])/g, (_, s, c) => s + c.toUpperCase());
    }
    // mixed case → force first letter up, keep the rest (DeShawn, McDonald)
    const i = word.search(/[a-zA-Z]/);
    return i < 0 ? word : word.slice(0, i) + word[i].toUpperCase() + word.slice(i + 1);
  };

  const words = name.trim().split(/\s+/);
  return words
    .map((word, idx) => {
      const bare = word.toLowerCase().replace(/[^a-z]/g, '');
      const isFirst = idx === 0;
      const isLast = idx === words.length - 1;
      if (PARTICLES.has(bare) && !isFirst && !isLast) {
        return word.toLowerCase();
      }
      return fixWord(word);
    })
    .join(' ');
};

export const capitalizeSentence = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};